import * as tslib_1 from "tslib";
import { OnInit } from '@angular/core';
import { Validators } from '@angular/forms';
import { FileNode, MediaTranslation } from 'src/app/utils/common-classes';
import { MatDialogRef, MatDialog } from '@angular/material';
import { ConfirmDialogComponent } from '../confirm-dialog/confirm-dialog.component';
export class RenameFileDialogComponent {
    constructor(dialogRef, data, fb, fileService, utils, dialog) {
        this.dialogRef = dialogRef;
        this.data = data;
        this.fb = fb;
        this.fileService = fileService;
        this.utils = utils;
        this.dialog = dialog;
    }
    ngOnInit() {
        this.form = this.fb.group({
            filename: ['', [Validators.required, Validators.pattern('^[^\\/?%*:|"<>\]+$')]],
            description: ['']
        });
        this.file = this.data.file;
        this.form.get('filename').setValue(this.file.name.substring(0, this.file.name.lastIndexOf('.')));
        this.form.get('description').setValue(this.file.description);
        this.selectedLanguageName = this.form.get('filename').value;
        this.selectedLanguageDescription = this.form.get('description').value;
        this.extension = this.file.name.substring(this.file.name.lastIndexOf('.'), this.file.name.length);
        this.utils.setDialogUnclosable(true);
    }
    closeDialog() {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            let _self = this;
            if (!_self.edited() && !_self.creatingNew) {
                _self.utils.setDialogUnclosable(false);
                _self.dialogRef.close(_self.file);
            }
            else {
                let title = yield _self.utils.translateKey("dialog.confirm.title.unsaved-changes");
                let message = yield _self.utils.translateKey("dialog.confirm.message.unsaved-changes");
                let data = { title: title, message: message };
                let confirmLeaveDialog = _self.dialog.open(ConfirmDialogComponent, { width: "400px", data: data, disableClose: true });
                confirmLeaveDialog.afterClosed().subscribe((confirm) => {
                    if (confirm) {
                        _self.utils.setDialogUnclosable(false);
                        _self.dialogRef.close(_self.file);
                    }
                });
            }
        });
    }
    submit() {
        let _self = this;
        _self.formSubmitAttempt = true;
        if (_self.form.valid) {
            let filename = _self.form.get('filename').value + _self.extension;
            let description = _self.form.get('description').value;
            _self.utils.showShortLoader();
            let mediaTranslation = new MediaTranslation();
            mediaTranslation.languageId = _self.selectedLanguage;
            mediaTranslation.name = filename;
            mediaTranslation.description = description;
            mediaTranslation.mediaFileId = _self.file.mediaFileId;
            _self.fileService.setFileTranslation(mediaTranslation).then((file) => {
                _self.file = FileNode.fromMediaFile(file);
                _self.updateData(_self.selectedLanguage);
                _self.creatingNew = false;
            }).catch((err) => {
                return _self.utils.getError(err);
            }).finally(() => {
                _self.utils.hideShortLoader();
            });
        }
    }
    deleteTranslation() {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            let _self = this;
            if (!_self.creatingNew && _self.file.translations && _self.file.translations.get(_self.selectedLanguage)) {
                let title = yield _self.utils.translateKey("dialog.confirm.title.delete-translation");
                let message = yield _self.utils.translateKey("dialog.confirm.message.delete-translation");
                let data = { title: title, message: message };
                let confirmLeaveDialog = _self.dialog.open(ConfirmDialogComponent, { width: "400px", data: data, disableClose: true });
                confirmLeaveDialog.afterClosed().subscribe((confirm) => {
                    if (confirm) {
                        let mediaTranslation = new MediaTranslation();
                        mediaTranslation.mediaTranslationId = _self.file.translations.get(_self.selectedLanguage).mediaTranslationId;
                        _self.fileService.deleteTranslation(mediaTranslation).then((file) => {
                            _self.file = FileNode.fromMediaFile(file);
                            _self.updateData(_self.selectedLanguage);
                            _self.creatingNew = false;
                        }).catch((err) => {
                            return _self.utils.getError(err);
                        }).finally(() => {
                            _self.utils.hideShortLoader();
                        });
                    }
                });
            }
            else {
                _self.updateData(_self.selectedLanguage);
                _self.creatingNew = false;
            }
        });
    }
    cancel() {
        let _self = this;
        _self.updateData(_self.selectedLanguage);
    }
    selectLanguage(language) {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            let _self = this;
            if (language != _self.selectedLanguage) {
                if (!_self.edited() && !_self.creatingNew) {
                    _self.updateData(language);
                }
                else {
                    let title = yield _self.utils.translateKey("dialog.confirm.title.unsaved-changes");
                    let message = yield _self.utils.translateKey("dialog.confirm.message.unsaved-changes");
                    let data = { title: title, message: message };
                    let confirmLeaveDialog = _self.dialog.open(ConfirmDialogComponent, { width: "400px", data: data, disableClose: true });
                    confirmLeaveDialog.afterClosed().subscribe((cancel) => {
                        if (cancel) {
                            _self.updateData(language);
                            _self.creatingNew = false;
                        }
                    });
                }
            }
        });
    }
    updateData(language) {
        let _self = this;
        let file = _self.file;
        _self.selectedLanguageName = "";
        _self.selectedLanguageDescription = "";
        if (language) {
            if (file.translations.get(language)) {
                if (_self.file.translations.get(language).name && _self.file.translations.get(language).name.lastIndexOf('.') > -1) {
                    _self.selectedLanguageName = _self.file.translations.get(language).name.substring(0, _self.file.translations.get(language).name.lastIndexOf('.'));
                }
                else {
                    _self.selectedLanguageName = _self.file.translations.get(language).name;
                }
                _self.selectedLanguageDescription = _self.file.translations.get(language).description || "";
            }
        }
        else {
            _self.selectedLanguageName = _self.file.name.substring(0, _self.file.name.lastIndexOf('.'));
            _self.selectedLanguageDescription = _self.file.description || "";
        }
        _self.form.get('filename').setValue(_self.selectedLanguageName);
        _self.form.get('description').setValue(_self.selectedLanguageDescription);
        _self.selectedLanguage = language;
    }
    edited() {
        let _self = this;
        return _self.selectedLanguageName != _self.form.get('filename').value || _self.selectedLanguageDescription != _self.form.get('description').value;
    }
    createNewTranslation() {
        let _self = this;
        _self.creatingNew = true;
    }
}
